export function getCurrentUser() {
  try {
    if (typeof window === 'undefined') return null;
    const raw = window.localStorage?.getItem?.('current_user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return Boolean(getCurrentUser());
}

